var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useMemo } from 'react';
import { useApiQuery } from '../api';
import { createSession } from './utils';
import { SessionQuery } from './session-query';
export var useSession = function () {
    var endpoint = useMemo(function () {
        return new SessionQuery();
    }, []);
    var sessionQuery = useApiQuery({
        endpoint: endpoint,
        options: {
            keepPreviousData: true,
        },
    });
    var session = useMemo(function () {
        if (sessionQuery.data) {
            return createSession(sessionQuery.data);
        }
        return sessionQuery.data;
    }, [sessionQuery.data]);
    return __assign(__assign({}, sessionQuery), { data: session });
};
